module.exports = __webpack_public_path__ + "miaas.ed57f7713f3be6e1e2b7a685df8120b3.png";